module.exports = __webpack_public_path__ + "static/media/m_eyeshape_upturned_amber.19f597ff.png";